import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Media, Button, Spinner } from 'reactstrap';
import { BusyIndicator } from './BusyIndicator';
import { handleResponse } from '../utils/handlers';

import styles from './TrackingDetails.module.css';

function TrackingDetails(props) {

    let history = useHistory();
    let { authenticatedUser } = useContext(AuthContext);

    const [trackingDetails, setTrackingDetails] = useState(null);
    const [busy, setBusy] = useState(false);

    var consignment = history.location.state;

    useEffect(() => {

        if (consignment && consignment.consignmentID) {

            setBusy(true);

            fetch(`api/public/track/consignment?consignmentId=${consignment.consignmentID}`, {
                credentials: 'include'
                })
                .then(handleResponse)
                .then(data => {

                    setTrackingDetails(data);

                    setBusy(false);
                })
                .catch(error => {
                    setBusy(false);
                    alert(error);
                });
        }

    }, [consignment]);

    function recordScans(scanType) {

        var time = moment();

        var scans = {
            scannerCode: scanType,
            time: time.toISOString(),
            depot: authenticatedUser?.fmeUserInfo?.defaultDepot?.id,
            vehicle: null,
            driver: null,
            barcodes: [
                {
                    barcode: trackingDetails.connoteNumber,
                    consignmentReference: trackingDetails.connoteNumber,
                    status: null,
                    time: time.toISOString(),
                    notes: null
                }
            ],
            status_code: null,
            to_depot: null,
            home_delivery: false,
            podName: null,
            signature: null
        };

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');

        fetch(`api/scans`, {
            credentials: 'include',
            method: 'POST',
            headers: headers,
            body: JSON.stringify(scans)
            })
            .then(response => {
                alert('Scan submitted.');
            })
            .catch(error => console.log(error));
    }

    return busy ?
        <BusyIndicator isBusy={busy} /> : (
            <React.Fragment>
                {
                    trackingDetails &&
                    trackingDetails.trackingRecords &&
                    trackingDetails.trackingRecords.map((tr, index) =>
                        <Media key={`media_${index}`}>
                            <Media body>
                                <p>
                                    {`${tr.trackEvent}, ${tr.location}, ${tr.scanDateTime ? moment(tr.scanDateTime).format('DD/MM HH:mm') : tr.status}`}
                                </p>
                                {
                                    tr.trackEvent === 'Delivered' && tr.expectedDate &&
                                    <p>
                                        {`Delivery Expected ${moment(tr.expectedDate).format('DD/MM')}`}
                                    </p>
                                }
                            </Media>
                        </Media>
                    )
                }
                <div className={styles.buttonGroup}>
                    <div>
                        <Button className={styles.btn} color="primary" onClick={e => recordScans('IND')}>In Depot</Button>
                        <Button className={styles.btn} color="primary" onClick={e => recordScans('UNL')}>Unload</Button>
                    </div>
                    <div>
                        <Button className={styles.btn} color="primary" onClick={e => history.push(`/consignment/${consignment.consignmentID}`)} block>Back</Button>
                    </div>
                </div>
            </React.Fragment>
        );
}

export { TrackingDetails };